import { styled } from '@mui/system'
import { fontSizes, colors } from '../../Components/consts'

export const Inner = styled('div')(({ theme }) => ({
  minHeight: '90vh',
  '& h1': {
    fontSize: fontSizes.xlarge,
    margin: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.large,
      margin: theme.spacing(3, 0),
    },
  },
}))

export const TeamCol = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  '& img': {
    height: 40,
    margin: 10,
    [theme.breakpoints.down('sm')]: {
      height: 25,
      margin: 5,
    },
  },
}))

export const InjuryTable = styled('table')(({ theme }) => ({
  width: '100%',
  borderCollapse: 'collapse',

  [theme.breakpoints.up('md')]: {
    maxWidth: '90%',
  },

  '& th': {
    fontSize: 12,
    color: colors.text,
    fontWeight: 'normal',
    textTransform: 'uppercase',
    height: theme.spacing(3),
    '&:first-of-type': {
      textAlign: 'left',
    },
    '&:last-child': {
      width: '30%',
      textAlign: 'left',
      marginLeft: 2,
    },
  },
  '& tbody tr': {
    borderTop: `1px solid ${colors.lightGrey}`,
    '&:first-of-type': {
      borderTop: 0,
    },
  },

  '& tbody td': {
    fontSize: 18,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    color: colors.text,
    width: '33%',
    minWidth: 50,
    textAlign: 'center',
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
    '&:first-of-type': {
      width: 'auto',
      textAlign: 'left',
    },
    '&:nth-of-type(2)': {
      width: 'auto',
      textAlign: 'center',
    },
    '&:last-child': {
      width: '30%',
      textAlign: 'left',
    },
    '& a': {
      color: colors.text,
      textDecoration: 'none',
    },
    '& svg': {
      width: 18,
      marginLeft: theme.spacing(1),
    },
  },
  '& tfoot p': {
    fontWeight: 'normal',
    fontSize: 14,
  },
}))
